// src/Lexprompt/components/DepartmentFilter.jsx
import React from "react";
import "../pages/DepartmentFilter.css";

const departments = [
  "Trending",
  "All",
  "Marketing",
  "Sales",
  "IT",
  "Operations",
  "HR",
  "Finance",
  "Legal",
];

export default function DepartmentFilter({ selected, onSelect }) {
  return (
    <div className="department-filter">
      {departments.map((dept) => (
        <button
          key={dept}
          className={`dept-tab ${selected === dept ? "active" : ""}`}
          onClick={() => onSelect(dept)}
        >
          {dept}
        </button>
      ))}
    </div>
  );
}
